// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3plAR","label":"Completed_label__1Kaee"};